module.exports = __webpack_public_path__ + "assets/img/Clementi MRT.610122ac.jpg";